import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ContentLoader from 'react-content-loader';
import useLoaderEditingAttrs from '../internal/useLoaderEditingAttrs';
import styles from '../internal/PointChart/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Loader = _ref => {
  let {
    editing = false
  } = _ref;
  const editingAttrs = useLoaderEditingAttrs(editing);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: styles.loader
  }, editingAttrs), {}, {
    children: /*#__PURE__*/_jsx(ChartLoader, {})
  }));
};

export const ChartLoader = () => /*#__PURE__*/_jsxs(ContentLoader, {
  viewBox: "0 0 400 220",
  style: {
    width: '100%',
    height: '90%'
  },
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "40%",
    cy: "65",
    r: "32"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "65%",
    cy: "150",
    r: "16"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "80%",
    cy: "79",
    r: "27"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "26%",
    cy: "160",
    r: "22"
  })]
});
export default Loader;